import { isEqual } from "lodash";

import { Model } from "../../shared/models/model";

export class VisitType extends Model {
  constructor(attributes) {
    if (attributes.specialtyIds) {
      attributes.specialtyIds.sort();
    }

    super(attributes);
  }

  get defaults() {
    return {
      id: undefined,
      decisionTreeId: undefined,

      matchName: undefined,
      name: undefined,
      category: undefined,
      description: undefined,
      help: undefined,

      validForNewPatient: undefined,
      validForReturningPatient: undefined,

      minimumAge: undefined,
      maximumAge: undefined,
      verifyProviderAgeRange: undefined,

      specialtyIds: undefined,
      excludeSpecialties: undefined,
    };
  }

  validFor(patientType) {
    if (!patientType) {
      return true;
    }

    return patientType === "new" ? this.validForNewPatient : this.validForReturningPatient;
  }

  hasMatchingSpecialtyRestrictions(visitType) {
    if (!this.specialtyIds || !visitType.specialtyIds) {
      return false;
    }

    if (this.excludeSpecialties !== visitType.excludeSpecialties) {
      return false;
    }

    return isEqual(this.specialtyIds, visitType.specialtyIds);
  }

  hasNoSpecialtyRestrictions() {
    return !this.specialtyIds || this.specialtyIds.length === 0;
  }
}
